import { addressBookPaginationStyles } from "@insite/content-library/Widgets/Addresses/AddressBookPagination";
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@guestsupply/Overrides/Components/AddressInfoDisplay";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const addressInfoSharedStyle: TypographyProps = {
    as: "p",
    size: 14,
    weight: 400,
    color: "text.main",
    css: css`
        margin-bottom: 0;
        line-height: 21px;
    `,
};
addressInfoDisplayStyles.wrapper = {
    css: css`
        font-style: normal;
        max-width: 100%;
    `,
};
addressInfoDisplayStyles.companyNameText = {
    as: "p",
    size: 14,
    weight: "bold",
    css: css`
        line-height: 16px;
        margin-bottom: 8px;
    `,
};

addressInfoDisplayStyles.phoneText = {
    ...addressInfoSharedStyle,
};

addressInfoDisplayStyles.cityStatePostalCodeText = {
    css: css`
        margin-bottom: 8px;
    `,
};

addressInfoDisplayStyles.address1Text = {
    ...addressInfoSharedStyle,
};

addressInfoDisplayStyles.address2Text = {
    ...addressInfoSharedStyle,
};

addressInfoDisplayStyles.address3Text = {
    ...addressInfoSharedStyle,
};
addressInfoDisplayStyles.address4Text = {
    ...addressInfoSharedStyle,
};

addressInfoDisplayStyles.customerNameText = {
    css: css`
        display: flex;
        align-items: center;
        white-space: pre;
        flex-wrap: wrap;
    `,
};

addressInfoDisplayStyles.firstNameText = {
    ...addressInfoSharedStyle,
};

addressInfoDisplayStyles.lastNameText = {
    ...addressInfoSharedStyle,
};

addressInfoDisplayStyles.attentionText = {
    ...addressInfoSharedStyle,
};
addressInfoDisplayStyles.faxText = {
    ...addressInfoSharedStyle,
};
addressInfoDisplayStyles.emailText = {
    ...addressInfoSharedStyle,
};
// XNG-CHANGES-GSS-576
addressInfoDisplayStyles.countryText = {
    ...addressInfoSharedStyle,
    as: "span",
};
addressInfoDisplayStyles.cityText = {
    ...addressInfoSharedStyle,
    as: "span",
};
addressInfoDisplayStyles.stateText = {
    ...addressInfoSharedStyle,
    as: "span",
};
addressInfoDisplayStyles.postalCodeText = {
    ...addressInfoSharedStyle,
    as: "span",
};
